module.exports = __webpack_public_path__ + "static/media/vis9.655017be.jpeg";